(function($) {

if($("body").hasClass("home")) {
    if(!$("body").hasClass("noAnim")) {
        $(".main-nav").hide();
        $(".hero-slider-nav").hide();
        $(".hero-slider-nav-item").hide();

        setTimeout(function () {
            $(".main-nav").fadeIn(750);
            $(".hero-slider-nav").fadeIn(750);
            $(".hero-slider-nav-item").fadeIn(750);
            $(".skip-intro").fadeOut();
        }, 6800);
    }
}

})( jQuery );